// extracted by mini-css-extract-plugin
export default {"emptyList":"IsaacEmpty_emptyList__bGjUX","emptyListImage":"IsaacEmpty_emptyListImage__box89"};